import "../../styles/Offerings/Dream.css";

const Dream = () => {
  return (
    <div className="dream-container">
      <div className="dream-innercontainer">
        <div className="dream-title">Ready To Build Your Dream Startup?</div>
        <div className="dream-step-container">
          <div className="dream-step-innercontainer">
            <div className="dream-desc">
              <div>
                Get a <b>FREE</b> Startup Evaluation Today! <br />
                <b>Worth ₹10K</b>
              </div>
            </div>
          </div>
          <div className="dream-step-innercontainer">
            <div className="dream-desc">
              <div>
                Let’s transform your idea into a{" "}
                <b>successful, loved business.</b>
              </div>
            </div>
          </div>
          <div className="dream-step-innercontainer">
            <div className="dream-desc no-cap">
              <div className="dream-contact-container">
                <div className="dream-contact-title">Get Started Now</div>
                <div>
                  <div className="dream-contact-desc">📞 +91-9975570015</div>
                  <div className="dream-contact-desc">
                  <a href="mailto:lovencode@gmail.com" style={{textDecoration:"none", color:"white"}}>
                    📧 lovencode@gmail.com
                  </a>
                  </div>
                  <div className="dream-contact-desc">
                  <a href="/" style={{textDecoration:"none", color:"white"}} target="_blank">
                    🌐 www.LovenCoders.com
                  </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dream;
